import { Page } from "@sunrun/sales-experience-shared";
import { useAnalyticsAdapter } from "adapters/analytics";
import { IFrame } from "components/atoms/IFrame";

type Props = {
  page: Page;
  jwtResponse: { jwt: string; email: string };
};

const AnalyticsIFrame = ({ page, jwtResponse }: Props) => {
  const { basePath, ref, src, title } = useAnalyticsAdapter(page);

  const queryString = `jwt=${jwtResponse.jwt}&email=${jwtResponse.email}`;
  const baseUrl = `${basePath}?${queryString}`;
  const srcUrl = `${src}?${queryString}`;

  return <IFrame basePath={baseUrl} ref={ref} title={title} src={srcUrl} />;
};

export { AnalyticsIFrame };
